import { ReactElement } from 'react';
import { Tooltip } from 'antd';
import { StyledIconButton } from './styles';

type Props = {
    icon: ReactElement;
    tooltipText: string;
    disabled?: boolean;
    disabledText?: string;
    loading?: boolean;
    onClick?: React.MouseEventHandler<HTMLElement>;
};

const IconButton = ({
    icon,
    tooltipText,
    disabled = false,
    loading,
    disabledText = 'This functionality is disabled',
    onClick,
}: Props) => {
    const button = <StyledIconButton loading={loading} icon={icon} disabled={disabled} onClick={onClick} />;

    return (
        <Tooltip title={disabled ? disabledText : tooltipText}>
            <span>{button}</span>
        </Tooltip>
    );
};

export default IconButton;
